import { Box, Typography } from '@mui/material';

export default function SocialSummary({ summary }) {
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: 'primary.lighter',
        borderRadius: 1,
        mb: 3,
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Summary
      </Typography>
      <Box sx={{ display: 'flex', gap: 3 }}>
        <Typography variant="body2">Facebook Pages: {summary.totalFacebookPages}</Typography>
        <Typography variant="body2">
          Instagram Accounts: {summary.totalInstagramAccounts}
        </Typography>
      </Box>
    </Box>
  );
}
